import React, { useState, useEffect } from "react";
import './OrbitReferences.scss';
import Reference from "../../partials/Reference/Reference";
import SubReference from "../../partials/SubReference/SubReference";
import data from "./references.json"
import Scroll from "../../partials/Scroll/Scroll"


const OrbitReferences = props => {
	const [cleanup, setCleanup] = useState(false)
	const data = props.data;

	console.log("Orbit Data: ", data)
	const chapters = data.map((reference, i) => {
		return <Reference index={i} data={reference} subReferences={reference.zSubReferences} header={reference.header} />
	})

	const handleButtonClick = () => {
		setCleanup(true);
		setTimeout(() => {
			if (props.onClose) props.onClose();
			if (props.onComplete) props.onComplete();
		}, (props.instant === true ? 0 : 600))

	}

	const getAnimationClasses = () => {
		if (props.instant === true) return '';
		return cleanup ? 'cleanup' : 'not-cleanup'
	}

	return (
		<div className={`Popup ${getAnimationClasses()} ${props.class || ''} ${props.centered === false ? 'not-centered' : 'centered'} `}>
			<div className="scrim" style={props.style || {}} onClick={props.toggle}></div>
			<div className={`OrbitReferences`}>

				<Scroll>
					<div className={`modal-container`}>
					<div className={`close-modal`} onClick={props.toggle}>X</div>			
						<h1>Orbit References</h1>
						{chapters}
					</div>
				</Scroll>
			</div>
		</div>
	)
}

export default OrbitReferences
